@if (!isAccountLocked && !isNotUberConnected) {
  <div class="container">
    <div class="row">
      <div class="login-container col-lg-6 col-sm-12 text-center offset-lg-3">
        <div class="login-box text-center">
          <div class="title">{{ isPhoneUpdate ? 'New Phone Number Verification' : 'User Verification' }}</div>
          <div class="sub-title">
            @if (isPhoneUpdate) {
              A one-time password (OTP) has been sent to your new phone number. 
              <!-- ending in {{ currentPhoneLastFour }}. -->
            } @else {
              A one-time password (OTP) has been sent to your registered
              phone number ending in {{ lastDigits }}.
            }
          </div>
          <form
            (ngSubmit)="onSubmit()"
            [formGroup]="verifyForm"
            class="form-wrapper"
            >
            <div class="form-group text-start mt-3 mb-3">
              <label class="control-label mb-1" for="otp"
                >6 digit one time verification code</label
                >
                <input
                  class="form-control show-validation"
                  id="user-verification-otp-input"
                  name="otp"
                  formControlName="otp"
                  type="text"
                  [maxLength]="6"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  />
                @if (submitted && verifyForm.controls?.['otp']?.errors?.['required']) {
                  <p
                    class="error-msg"
                    id="user-verification-otp-required-error-message"
                    >
                    This field is required
                  </p>
                }
                @if (submitted && verifyForm.controls?.['otp']?.errors?.['pattern']) {
                  <p
                    class="error-msg"
                    id="user-verification-otp-pattern-error-message"
                    >
                    Please enter a valid verification code
                  </p>
                }
              </div>
              <button
                class="btn btn-normal btn-pink mt-3 btn-pink-filled verify-btn"
                id="user-verification-submit-button"
                type="submit"
                [disabled]="submitting"
                >
                <p class="load-btn small-btn">
                  @if (!submitting) {
                    Verify OTP
                  }
                  @if (submitting) {
                    <mat-spinner [diameter]="17"></mat-spinner
                      >Processing
                    }
                  </p>
                </button>
                @if (isPhoneUpdate) {
                  <div class="col-lg-12 col-sm-12 text-center verify-bottom-block">
                    <p class="text-start mt-4">
                      @if (!isTimer) {
                        <span class="resend_link">
                          Didn't receive the code?
                          <button
                            type="button"
                            class="btn btn-primary resend-button"
                            id="user-verification-resend-phone-button"
                            (click)="resendPhoneOtp()"
                          >
                            <p class="load-btn small-btn">
                              @if (!resetSubmitting) {
                                Resend code
                              }
                              @if (resetSubmitting) {
                                <mat-spinner [diameter]="17"></mat-spinner>Requesting OTP
                              }
                            </p>
                          </button>
                        </span>
                      }
                      @if (isTimer) {
                        <span class="resend_timer">
                          You can resend the code in {{ timeLeft }} seconds...
                        </span>
                      }
                    </p>
                  </div>
                }
                @if (!isPhoneUpdate) {
                <div
                  class="col-lg-12 col-sm-12 text-center verify-bottom-block"
                  >
                  <p class="text-start mt-4">
                    @if (!isTimer) {
                      <span class="resend_link">
                        Didn't receive the code?
                        <button
                          type="button"
                          class="btn btn-primary resend-button"
                          id="user-verification-resend-button"
                          (click)="sentOtp('resend')"
                          >
                          <p class="load-btn small-btn">
                            @if (!resetSubmitting) {
                              Resend code
                            }
                            @if (resetSubmitting) {
                              <mat-spinner
                                [diameter]="17"
                                ></mat-spinner
                                >Requesting OTP
                              }
                            </p>
                          </button>
                        </span>
                      }
                      @if (isTimer) {
                        <span class="resend_timer">
                          You can resend the code in
                          {{ timeLeft }} seconds...
                        </span>
                      }
                    </p>
                    <p class="text-start mt-3">
                      Lost the registered device? Please contact us to get
                      access.
                      <br />Email Us:
                      <a href="mailto:contact&#64;playoctopus.com"
                        id="user-verification-contact-link"
                        >contact&#64;playoctopus.com</a
                        >
                        <br />Call Us: (240) 366-5877 (Monday to Thursday
                        10am - 5pm EST and Friday 10am - 1pm EST)
                    </p>
                    <p class="text-start mt-2 phone-reset-title" id="user-verification-reset-phone-copy">
                      Don't have access to your phone?
                    </p>
                    <button
                      type="button"
                      class="btn btn-normal btn-pink btn-pink-filled mt-2"
                      id="user-verification-reset-phone-button"
                      (click)="resetPhoneNumber()"
                      [disabled]="resetPhoneSubmitting"
                    >
                      <p class="load-btn small-btn">
                        @if (!resetPhoneSubmitting) {
                          Reset Phone Number
                        }
                        @if (resetPhoneSubmitting) {
                          <mat-spinner [diameter]="17"></mat-spinner>Processing
                        }
                      </p>
                    </button>
                    </div>
                }
                  </form>
                </div>
              </div>
            </div>
          </div>
        }
        @if (isAccountLocked && !isNotUberConnected) {
          <div
            class="container black-link account-locked"
            >
            <div class="row">
              <div class="col-md-12 col-lg-12 col-sm-12 text-center">
                <img
                  src="/assets/images/octopus-generic-header.png"
                  alt="All Set!"
                  height="100%"
                  width="60%"
                  />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-lg-12 col-sm-12 text-center">
                <div style="margin-top: 1em">
                  <h5 class="mb-4">
                    <mat-icon class="me-2">warning</mat-icon>
                    <span
                      >Your Account Is Locked
                      @if (unlockTimeString) {
                        <span
                          >&nbsp;for 24 hours.</span
                          >
                      }</span
                        >
                      </h5>
                      <p>
                        Oops! Your Driver Dashboard has been locked
                        @if (unlockTimeString) {
                          <span
                            >until {{ unlockTimeString }}</span
                            >
                          }
                          @if (!isPhoneLocked) {
                            because an incorrect password or verification code was used
                            too many times.
                          }
                          <br />
                          <br />
                          <strong>
                            Your Octopus account is still active and your tablet is
                            continuing to award points as normal.
                          </strong>
                          Only your <strong>Driver Dashboard</strong> has been
                          temporarily locked to protect your information.
                          <br />
                          <br />
                          @if (unlockTimeString) {
                            Your account will automatically unlock at
                            {{ unlockTimeString }}.
                            <br />
                            <br />
                          }
                          @if (unlockTimeString) {
                            Questions? Contact our support team at:
                            <a href="https://playoctopus.com/help/dashboard-lock/" id="user-verification-help-unlock-time">
                              playoctopus.com/help/dashboard-lock/</a
                              >.
                            }
                            @if (!unlockTimeString) {
                              Please contact our support team at:
                              <a href="https://playoctopus.com/help/dashboard-lock/" id="user-verification-help-unlock-support">
                                playoctopus.com/help/dashboard-lock/</a
                                >
                                to have your account unlocked and login again.
                              }
                            </p>
                          </div>
                          <div style="margin-top: 2em">
                            <h5 class="mb-2">
                              <u>En Español</u>
                            </h5>
                            <p>
                              ¡Ups! Su panel de control del conductor se ha bloqueado
                              hasta el día {{ unlockTimeString }}@if (!isPhoneLocked) {, porque se utilizó una
                              contraseña o código de verificación incorrecto demasiadas
                              veces.
                              }
                              <br />
                              <br />
                              Su cuenta de Octopus aún está activa y su tableta continúa
                              otorgando puntos normalmente. Solo su panel de control del
                              conductor se ha bloqueado temporalmente para proteger su
                              información.
                              <br />
                              <br />
                              Por favor espere 24 horas antes de intentar iniciar sesión
                              nuevamente. Su cuenta se desbloqueará automáticamente a las
                              {{ unlockTimeString }}.
                              <br />
                              <br />
                              ¿Preguntas? Póngase en contacto con nuestro equipo de
                              soporte en:
                              <a href="https://playoctopus.com/help/dashboard-lock/" id="user-verification-help-spanish">
                                playoctopus.com/help/dashboard-lock/</a
                                >.
                              </p>
                            </div>
                          </div>
                        </div>
                        <br />
                      </div>
                    }
                    @if (!isAccountLocked && isNotUberConnected) {
                      <div class="container">
                        <octo-uber-connect></octo-uber-connect>
                      </div>
                    }
